import React, {useEffect, useState} from 'react';
import { Box, Typography, Paper, Container, Alert } from '@mui/material';
import PersistentDrawerLeft from '../../components/NewDrawer';
import TFASetup from '../../components/TFASetup';
import useCallDataApi from "../../hooks/data";

const TFASetupPage = () => {
    const {getData} = useCallDataApi('tfa')
    const [tfaEnabled, setTfaEnabled] = useState(true)
    useEffect(() => {
        getData('is_active').then(r => setTfaEnabled(r?.tfa_enabled))
    }, []);

    return (
        <PersistentDrawerLeft title="Kétfaktoros hitelesítés beállítása">
            <Container maxWidth="md">
                <Box sx={{ py: 4 }}>
                    {tfaEnabled ? (
                        <Paper sx={{ p: 3 }}>
                            <Alert severity="success" sx={{ mb: 2 }}>
                                A kétfaktoros hitelesítés már aktív a fiókján!
                            </Alert>
                            <Typography variant="body1" paragraph>
                                Az Ön fiókja védett a kétfaktoros hitelesítéssel. Minden bejelentkezéskor szükséges lesz megadnia
                                a Google Authenticator által generált kódot a jelszava mellett.
                            </Typography>
                        </Paper>
                    ) : (
                        <>
                            <Paper sx={{ p: 3, mb: 3 }}>
                                <Typography variant="h6" gutterBottom>
                                    Mi az a kétfaktoros hitelesítés?
                                </Typography>
                                <Typography variant="body1" paragraph>
                                    A kétfaktoros hitelesítés (2FA) egy további biztonsági réteget ad a fiókjához.
                                    A bejelentkezéshez nem elég csak a jelszó, hanem egy egyedi kódot is meg kell adni,
                                    amit a Google Authenticator alkalmazás generál.
                                </Typography>
                                <Typography variant="body1" paragraph>
                                    A Google Authenticator alkalmazást ingyenesen letöltheti:
                                </Typography>
                                <Typography variant="body1" component="div" sx={{ pl: 2 }}>
                                    <ul>
                                        <li>iOS: <a href="https://apps.apple.com/app/google-authenticator/id388497605" target="_blank" rel="noopener noreferrer">App Store</a></li>
                                        <li>Android: <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="noopener noreferrer">Google Play</a></li>
                                    </ul>
                                </Typography>
                            </Paper>

                            <Paper sx={{ p: 3 }}>
                                <TFASetup />
                            </Paper>
                        </>
                    )}
                </Box>
            </Container>
        </PersistentDrawerLeft>
    );
};

export default TFASetupPage; 